// @ts-check
import SmrClient from "Utils/Requests/SmrClient";

class MkMessNotifRequests {
    /**
     * @param {WebMessageCreateRequest} dataToSend 
     * @returns {Promise<WebMessageCreateResponse>}
     */
    async CreateMessage(dataToSend) {
        return await SmrClient.FetchJson({
            url: 'MkMessNotif/CreateMessage',
            method: "POST",
            body: dataToSend
        });
    }

    /**
     * @returns {Promise<Object.<number, string>>}
     */
    async GetActiveUsers() {
        return await SmrClient.FetchJson({
            url: 'MkMessNotif/GetActiveUsers',
            method: "GET"
        });
    }

    /**
     * @param {number} start
     * @param {number} length
     * @returns {Promise<WebRecords<WebMkMessNotif>>}
     */
    async GetMessages(start, length) {
        return await SmrClient.FetchJson({
            url: 'MkMessNotif/GetMessages',
            method: "POST",
            body: { start: start, length: length },
            bodyIsUrlParams: true
        });
    }

    /**
     * @param {number} messageId
     * @param {number} start
     * @param {number} length
     * @returns {Promise<WebMessageInfo>}
     */
    async GetMessageViewInfo(messageId, start, length) {
        return await SmrClient.FetchJson({
            url: 'MkMessNotif/GetMessageViewInfo',
            method: "POST",
            body: { messageId: messageId, start: start, length: length },
            bodyIsUrlParams: true
        });
    }

    /**
     * @param {number[]} messageIds
     */
    async DeleteMessages(messageIds) {
        await SmrClient.FetchJson({
            url: 'MkMessNotif/DeleteMessages',
            method: "POST",
            body: messageIds
        });
    }

    /**
     * @param {number} messageId 
     * @param {string} userLid 
     */
    async CancelMessageForUser(messageId, userLid) {
        await SmrClient.FetchJson({
            url: 'MkMessNotif/CancelMessageForUser',
            method: "POST",
            body: { messageId: messageId, userLid: userLid },
            bodyIsUrlParams: true
        });
    }
}

export default new MkMessNotifRequests;